module.exports = __webpack_public_path__ + "asset/img/qstn_submitted_icon.3cf102ac.png";